import { useCallback } from "react";
import { getStorageValue } from "../storage";
import { useTaskSettings } from "./use-task-settings";

export const useDefaultFilters = () => {
    const { taskSettings } = useTaskSettings();

    const handleBasicDefaultFilters = (defaultStateValue, type, users, storageKey, assignments, onPopulateUserAssignments, formFilters) => {
        const stateFilter = {
            id: "state",
            value: defaultStateValue,
        };
        const newDefaultFilter = [
            {
                id: "state",
                value: defaultStateValue,
            },
        ];

        const storedFilter = formFilters || getStorageValue(storageKey) || [];
        const filters = storedFilter.filters ? storedFilter.filters : storedFilter;
        const storedStateFilter = filters.find((f) => f.id === "state");
        const storedTeam = storedFilter.find((team) => team.id === "assignmentGroupKey");
        const storedUser = storedFilter.find((assignedUser) => assignedUser.id === "assignedUserInfo");
        const user = getStorageValue("user");
        const loggedUser = users.find(({ email }) => user.email === email);

        // set default values ONLY if no form values were provided
        if (!formFilters && !storedTeam && loggedUser && !taskSettings[type].preserveDefault) {
            const relatedTeams = onPopulateUserAssignments(loggedUser.value.toString(), assignments);

            if (relatedTeams.length > 0) {
                storedFilter.push({ id: "assignmentGroupKey", value: relatedTeams[0].value });
            }
        }

        // set default values ONLY if no form values were provided
        if (!formFilters && !storedUser && loggedUser && !taskSettings[type].preserveDefault) {
            storedFilter.push({ id: "assignedUserInfo", value: loggedUser.value.toString() });
        }

        // formFilters is used only on Advanced Filters "Apply Filter" section - it will add this default filter if any other will be removed
        if (!storedStateFilter && !formFilters) {
            storedFilter.push({ ...stateFilter });
        }

        return storedFilter && Array.isArray(storedFilter) ? storedFilter : [...newDefaultFilter];
    };

    return useCallback(handleBasicDefaultFilters, [taskSettings]);
};
